import { Stack, Typography } from "@mui/material";

/**
 * A single label/value row used across the team billing, credits, checkout and
 * seat-picker surfaces. `emphasis` bolds both sides for total/summary rows.
 */
export const LabelValueRow = ({
  label,
  value,
  emphasis = false,
  valueColor,
}: {
  label: string;
  value: string;
  emphasis?: boolean;
  valueColor?: string;
}) => (
  <Stack direction="row" justifyContent="space-between" alignItems="center">
    <Typography
      variant="body2"
      color={emphasis ? "text.primary" : "text.secondary"}
      sx={{ fontWeight: emphasis ? 600 : 400 }}
    >
      {label}
    </Typography>
    <Typography
      variant="body2"
      sx={{ fontWeight: emphasis ? 700 : 600, fontVariantNumeric: "tabular-nums", color: valueColor }}
    >
      {value}
    </Typography>
  </Stack>
);
